export const handleOnClose = (alertId, onClose) => {
  onClose(alertId);
};

export const handleOnExited = (id, deregisterAlert, hasTopAlert) => {
  if (hasTopAlert) return;
  deregisterAlert(id);
};
